import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../api/api';

interface QuizCodeState {
    code: string | null;
    count: number | null;
    loading: boolean;
    error: string | null;
}

const initialState: QuizCodeState = {
    code: null,
    count: null,
    loading: false,
    error: null,
};

// Async thunk to fetch next code
export const fetchNextQuizCode = createAsyncThunk(
    'quizCode/fetchNext',
    async (_, { rejectWithValue }) => {
        try {
            // Fetch new code from API (reads from CSV and saves to DB)
            const response = await apiInstance.get('/quiz-code/next');
            
            if (response.data.success) {
                const { code, count } = response.data.data;
                return { code, count };
            } else {
                return rejectWithValue(response.data.message || 'Failed to fetch code');
            }
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || 'Error fetching quiz code');
        }
    }
);

const quizCodeSlice = createSlice({
    name: 'quizCode',
    initialState,
    reducers: {
        clearQuizCode: (state) => {
            state.code = null;
            state.count = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchNextQuizCode.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNextQuizCode.fulfilled, (state, action) => {
                state.loading = false;
                state.code = action.payload.code;
                state.count = action.payload.count;
            })
            .addCase(fetchNextQuizCode.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const { clearQuizCode } = quizCodeSlice.actions;
export default quizCodeSlice.reducer;